function menuSwimming() {
    let position = $(window).scrollTop();
    const header = $(".main-header");

    $(window).scroll( function() {
        let scroll = $(window).scrollTop();

        if ( scroll > position ) {

            header.removeClass("fixed");

        } else {

            //hore
            header.addClass("fixed");

            if ( scroll < 1 ) {
                header.removeClass("fixed");
            }

        }

        position = scroll;
    });
}

menuSwimming();